'use client';

import { trackCheckoutEditClick } from '../../analytics/checkout';
import { SummaryCard, type SummaryCardProps } from '../../partials/SummaryCard';
import type { CheckoutEditCard } from '../types';

interface CheckoutSummaryCardProps extends Omit<SummaryCardProps, 'onAction'> {
  trackingCard: CheckoutEditCard;
}

/** Client boundary for the checkout cards: server components cannot pass the click handler to the link themselves. */
export function CheckoutSummaryCard({ trackingCard, ...props }: CheckoutSummaryCardProps) {
  return <SummaryCard {...props} onAction={() => trackCheckoutEditClick(trackingCard)} />;
}
